"use client";

import { useEffect } from "react";
import type { PropsWithChildren } from "react";
import { Popper, PopperProps } from "@mui/material";

interface BasePopperProps {
  popperProps: PopperProps;
  closeOnBackgroundClick?: () => void;
}

function BasePopper({ children, popperProps, closeOnBackgroundClick }: PropsWithChildren<BasePopperProps>) {
  useEffect(() => {
    if (typeof closeOnBackgroundClick === "function") {
      const nextEl = document.getElementById("__next");

      const handleClick = () => {
        closeOnBackgroundClick();
        nextEl?.removeEventListener("click", handleClick);
      };

      nextEl?.addEventListener("click", handleClick);
      return () => {
        const nextEl = document.getElementById("__next");
        nextEl?.removeEventListener("click", handleClick);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popperProps.open]);

  return <Popper {...popperProps}>{children}</Popper>;
}

export default BasePopper;
